let RootModule: any;

if (process.env.NODE_ENV === "production") {
  RootModule = require("./Root.prod");
} else {
  RootModule = require("./Root.dev");
}

export default RootModule.default;
